import { useMutation, UseMutationResult } from '@tanstack/react-query';

import { getApiHost, getMutationFetchOptions, parseHttpResponse } from '../utils';

const putRewardsConsent = async (
  userId: string,
  restaurantId: string
): Promise<void> => {
  const apiHost = getApiHost();
  const url = new URL(`/api/customer/${userId}/rewards-consent`, apiHost);
  const body = { opted_in: false, restaurant_id: restaurantId };

  const response = await fetch(url, getMutationFetchOptions('PUT', body));

  if (!response.ok) {
    await parseHttpResponse(response);
  }
};

export const useRewardsOptOutMutation = (
  userId: string
): UseMutationResult<void, Error, string> =>
  useMutation({
    mutationFn: (restaurantId: string) =>
      putRewardsConsent(userId, restaurantId),
  });
